import GlobalBreadcrumbsMixin from "../../../shared/Mixins/GlobalBreadcrumbsMixin";
import ComponentMixin from "../../../shared/Mixins/ComponentMixin";

export default {
  mixins: [GlobalBreadcrumbsMixin, ComponentMixin],

  mounted () {
    this.setBreadcrumb("Invoice");
  }
};
